import { render, staticRenderFns } from "./AItalk2.vue?vue&type=template&id=54d79474&"
import script from "./AItalk2.vue?vue&type=script&lang=js&"
export * from "./AItalk2.vue?vue&type=script&lang=js&"
import style0 from "./AItalk2.vue?vue&type=style&index=0&id=54d79474&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports